import elementStateToggle from '../../../../../../src/js/modules/elementStateToggle';
import tabNavigation from '../../../../../../src/js/modules/tabNavigation';
import sliderTabNavigation from '../../../../../../src/js/modules/sliderTabNavigation';

window.addEventListener('load', () => {
    tabNavigation.init();
    sliderTabNavigation.init();

    elementStateToggle.init({
        triggerElementSelector: '.js-tab-navigation-link',
        toggleActiveElement: true,
        removeAllActiveClasses: false,
    });

    elementStateToggle.init({
        triggerElementSelector: '.js-accordion-header',
        toggleActiveElement: true,
        removeAllActiveClasses: false,
    });
});
